function getItemDiscountCode() {
  const searchParams = location.search;
  const decoded = decodeURI(searchParams.replace("?", ""));
  const params = decoded.split("&");
  for (const param of params) {
    if (param.includes("item_discount_code")) {
      return param.split("=")[1];
    }
  }
}

function getShippingFeeDiscountCode() {
  const searchParams = location.search;
  const decoded = decodeURI(searchParams.replace("?", ""));
  const params = decoded.split("&");
  for (const param of params) {
    if (param.includes("shipping_fee_discount_code")) {
      return param.split("=")[1];
    }
  }
}

(async () => {
  const itemDiscountCode = getItemDiscountCode();
  const shippingFeeDiscountCode = getShippingFeeDiscountCode();
  if (itemDiscountCode) {
    await fetch(`/discount/${itemDiscountCode}`)
  };
  if (shippingFeeDiscountCode) {
    await fetch(`/discount/${shippingFeeDiscountCode}`)
  }
})();
